export default "/images/da893d6149108827b8d6086352ddc0b7.avif";